/* Pop-up de bienvenue Inéa.
   - S'ouvre après le délai OU au pourcentage de défilement réglés dans l'éditeur, le premier des deux.
   - Une seule fois : plus affiché pendant 30 jours après avoir été vu ou fermé, plus jamais après une inscription.
   - ?popup=1 : ouverture immédiate pour tester, sans tenir compte ni modifier la mémoire du navigateur.
   - Inscription : formulaire client natif de Shopify envoyé en AJAX ; l'étape 2 ne s'affiche que si Shopify confirme. */
(function () {
  var root = document.getElementById('PopupBienvenue');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var KEY_SEEN = 'inea_popup_vu';
  var KEY_SUB = 'inea_popup_inscrit';
  var DAY = 86400000;
  var days = parseInt(root.dataset.days, 10) || 30;
  var delay = (parseInt(root.dataset.delay, 10) || 20) * 1000;
  var scrollPct = (parseInt(root.dataset.scroll, 10) || 50) / 100;
  var code = root.dataset.code || '';

  var preview = false, previewScratch = false;
  try {
    var pp = new URLSearchParams(window.location.search).get('popup');
    preview = pp === '1' || pp === '2';
    previewScratch = pp === '2';
  } catch (e) {}

  function store(k, v) { if (preview) return; try { window.localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }

  var path = window.location.pathname;
  if (/\/(cart|checkout|checkouts|account|challenge)(\/|$)/.test(path) || (window.Shopify && window.Shopify.designMode)) return;

  /* Retour d'un envoi classique (captcha Shopify ou page /challenge) : la page s'est rechargée.
     On rouvre le pop-up sur le résultat, seulement si c'est bien lui qui a été envoyé. */
  var KEY_SENT = 'inea_popup_envoi';
  var sent = false;
  try { sent = window.sessionStorage.getItem(KEY_SENT) === '1'; window.sessionStorage.removeItem(KEY_SENT); } catch (e) {}
  if (window.location.hash === '#PopupBienvenueForm') sent = true;
  var pageMarker = root.querySelector('#PopupBienvenueForm [data-pb-result]');
  var resume = null;
  if (sent && (pageMarker || /customer_posted=true/.test(window.location.search))) {
    resume = pageMarker && pageMarker.getAttribute('data-pb-result') === 'error' ? 'error' : 'success';
  }

  var auto = true;
  if (!preview && !resume) {
    if (read(KEY_SUB)) auto = false;
    var seen = parseInt(read(KEY_SEEN), 10);
    if (seen && Date.now() - seen < days * DAY) auto = false;
  }

  var pop = root.querySelector('.pb-pop');
  var form = root.querySelector('form');
  var email = root.querySelector('[data-pb-email]');
  var emailErr = root.querySelector('[data-pb-email-err]');
  var consent = root.querySelector('[data-pb-consent]');
  var consentErr = root.querySelector('[data-pb-consent-err]');
  var serverErr = root.querySelector('[data-pb-server-err]');
  var tagsInput = root.querySelector('[data-pb-tags]');
  var submit = root.querySelector('[data-pb-submit]');
  var submitLabel = root.querySelector('[data-pb-submit-label]');
  var step1 = root.querySelector('[data-pb-step="1"]');
  var step2 = root.querySelector('[data-pb-step="2"]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;
  var isOpen = false;
  var timer = null;

  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  function open(force) {
    if (isOpen) return;
    // Jamais par-dessus le panier latéral ouvert : on réessaie plus tard.
    if (!force && document.documentElement.classList.contains('iv4-cd-lock')) { timer = setTimeout(open, 8000); return; }
    isOpen = true;
    cleanup();
    store(KEY_SEEN, String(Date.now()));
    lastFocus = document.activeElement;
    step1.hidden = false;
    step2.hidden = true;
    root.hidden = false;
    document.documentElement.classList.add('pb-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () { if (!step1.hidden) focusEl(email); }, reduced ? 0 : 320);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    store(KEY_SEEN, String(Date.now()));
    root.classList.remove('is-open');
    setTimeout(function () {
      root.hidden = true;
      document.documentElement.classList.remove('pb-lock');
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) focusEl(lastFocus);
    }, reduced ? 0 : 300);
  }

  /* Déclenchement */
  function onScroll() {
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    if ((window.scrollY || doc.scrollTop) / max >= scrollPct) open();
  }
  function cleanup() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  }

  /* Fermeture : croix, « Non merci », clic sur le fond, Échap ; focus piégé */
  Array.prototype.forEach.call(root.querySelectorAll('[data-pb-close]'), function (b) { b.addEventListener('click', close); });
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      pop.querySelectorAll('button, input:not([type="hidden"]), a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (!pop.contains(document.activeElement)) { e.preventDefault(); focusEl(e.shiftKey ? last : first); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); focusEl(first); }
  }, true);

  /* Familles de saveurs */
  var fams = [];
  Array.prototype.forEach.call(root.querySelectorAll('[data-pb-fam]'), function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var tag = b.getAttribute('data-pb-fam');
      fams = on ? fams.concat(tag) : fams.filter(function (x) { return x !== tag; });
    });
  });
  function famNames() {
    return (fams || []).map(function (t) {
      var b = root.querySelector('[data-pb-fam="' + t + '"]');
      return b ? b.getAttribute('data-pb-fam-name').toLowerCase() : '';
    });
  }

  /* Messages d'erreur renvoyés par Shopify, traduits en français */
  function frenchError(fields) {
    var text = fields.map(function (f) { return f.field + ' ' + f.msg; }).join(' ').toLowerCase();
    if (/taken|already|déjà|existe/.test(text)) return 'Cette adresse est déjà inscrite à nos e-mails. Vous recevrez nos prochaines offres.';
    if (/invalid|invalide|format|valid/.test(text)) return 'Cette adresse e-mail n\'est pas valide. Vérifiez-la, par exemple prenom@exemple.fr.';
    if (/blank|vide|empty|required|obligatoire/.test(text)) return 'Entrez votre adresse e-mail pour recevoir votre code.';
    return 'L\'inscription n\'a pas abouti. Vérifiez votre adresse et réessayez dans un instant.';
  }

  function showServerError(msg) {
    serverErr.textContent = msg;
    serverErr.hidden = false;
  }

  function busy(on) {
    submit.disabled = on;
    submit.setAttribute('aria-busy', on ? 'true' : 'false');
    submitLabel.textContent = on ? 'Inscription en cours…' : (root.dataset.cta || 'Recevoir mon code');
  }

  function success() {
    if (!preview) { try { window.localStorage.setItem(KEY_SUB, '1'); } catch (e) {} }
    showScratch();
  }

  /* Carte à gratter */
  var KEY_REVEALED = 'inea_popup_gratte';
  var scratchBox = root.querySelector('[data-pb-scratch]');
  var canvas = root.querySelector('[data-pb-canvas]');
  var revealBtn = root.querySelector('[data-pb-reveal]');
  var after = root.querySelector('[data-pb-after]');
  var lead2 = root.querySelector('[data-pb-thanks-lead]');
  var revealed = false, ctx = null, drawing = false, last = null, moves = 0;

  function paintFoil() {
    var r = scratchBox.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
    ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var w = r.width, h = r.height;
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#9c7b45'); g.addColorStop(0.28, '#e8d5a6'); g.addColorStop(0.5, '#b8945a');
    g.addColorStop(0.72, '#f1e2bb'); g.addColorStop(1, '#a07e48');
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    // Grain et reflets
    for (var i = 0; i < 260; i++) {
      ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.22).toFixed(2) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.4, 1.4);
    }
    ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 14) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
    ctx.fillStyle = 'rgba(15,15,14,.82)';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '700 13px "DM Sans", system-ui, sans-serif';
    ctx.fillText('G R A T T E Z   I C I', w / 2, h / 2 - 12);
    ctx.font = '400 italic 22px "Fraunces", Georgia, serif';
    ctx.fillText('votre code vous attend', w / 2, h / 2 + 14);
  }

  function pos(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function scratchAt(p) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.strokeStyle = '#000'; ctx.fillStyle = '#000';
    ctx.lineWidth = 38; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath();
    if (last) { ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
    else { ctx.arc(p.x, p.y, 19, 0, Math.PI * 2); ctx.fill(); }
    last = p;
    if (++moves % 8 === 0 && cleared() > 0.45) reveal();
  }
  function cleared() {
    try {
      var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data, n = 0, t = 0;
      for (var i = 3; i < d.length; i += 4 * 40) { t++; if (d[i] < 40) n++; }
      return t ? n / t : 0;
    } catch (e) { return 1; }
  }
  canvas.addEventListener('pointerdown', function (e) { if (revealed) return; drawing = true; last = null; try { canvas.setPointerCapture(e.pointerId); } catch (x) {} scratchAt(pos(e)); scratchBox.classList.add('is-scratching'); });
  canvas.addEventListener('pointermove', function (e) { if (drawing && !revealed) scratchAt(pos(e)); });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { canvas.addEventListener(t, function () { drawing = false; last = null; }); });

  function reveal() {
    if (revealed) return;
    revealed = true; drawing = false;
    if (!preview) { try { window.localStorage.setItem(KEY_REVEALED, '1'); } catch (e) {} }
    scratchBox.classList.add('is-revealed');
    revealBtn.hidden = true;
    after.hidden = false;
    lead2.textContent = 'Bravo ! Votre code est valable sur votre première commande.';
    var names = famNames();
    if (names.length) lead2.textContent += ' On vous enverra en priorité les nouveautés ' + names.join(' et ') + '.';
  }
  revealBtn.addEventListener('click', function () { reveal(); focusEl(root.querySelector('[data-pb-copy]')); });

  function showScratch() {
    step1.hidden = true;
    step2.hidden = false;
    if (read(KEY_REVEALED) && !preview) { revealed = false; reveal(); }
    else { requestAnimationFrame(paintFoil); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!revealed) paintFoil(); }); }
    focusEl(root.querySelector('[data-pb-thanks]'));
  }
  window.addEventListener('resize', function () { if (!step2.hidden && !revealed) paintFoil(); });

  /* Ouverture à la demande : tout lien vers #grattage (bandeau, page produit) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#grattage"]');
    if (!a) return;
    e.preventDefault();
    open(true);
    if (read(KEY_SUB)) showScratch();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    serverErr.hidden = true;
    var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim());
    email.setAttribute('aria-invalid', okMail ? 'false' : 'true');
    emailErr.hidden = okMail;
    consent.setAttribute('aria-invalid', consent.checked ? 'false' : 'true');
    consentErr.hidden = consent.checked;
    if (!okMail) { focusEl(email); return; }
    if (!consent.checked) { focusEl(consent); return; }

    email.value = email.value.trim();
    tagsInput.value = ['newsletter', 'popup'].concat(fams).join(',');
    try { window.sessionStorage.setItem(KEY_SENT, '1'); } catch (e2) {}
    busy(true);

    fetch(form.action, {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)),
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(function (res) {
      var url = res.url || '';
      /* Shopify demande une vérification anti-robot : on envoie le formulaire normalement. */
      if (/\/challenge/.test(url)) { form.submit(); return null; }
      return res.text().then(function (html) { return { url: url, ok: res.ok, html: html }; });
    }).then(function (r) {
      if (!r) return;
      busy(false);
      try { window.sessionStorage.removeItem(KEY_SENT); } catch (e3) {}
      var doc = new DOMParser().parseFromString(r.html, 'text/html');
      var marker = doc.querySelector('#PopupBienvenueForm [data-pb-result]');
      if (marker && marker.getAttribute('data-pb-result') === 'error') {
        var fields = Array.prototype.map.call(marker.querySelectorAll('[data-pb-field]'), function (s) {
          return { field: s.getAttribute('data-pb-field'), msg: s.textContent };
        });
        showServerError(frenchError(fields));
        return;
      }
      if ((marker && marker.getAttribute('data-pb-result') === 'success') || /customer_posted=true/.test(r.url)) {
        success();
        return;
      }
      showServerError('L\'inscription n\'a pas pu être confirmée. Réessayez dans un instant.');
    }).catch(function () {
      busy(false);
      showServerError('Connexion impossible pour le moment. Vérifiez votre réseau et réessayez.');
    });
  });

  /* Copier le code */
  var copyBtn = root.querySelector('[data-pb-copy]');
  var copyMsg = root.querySelector('[data-pb-copy-msg]');
  copyBtn.addEventListener('click', function () {
    function fallback() {
      var r = document.createRange();
      r.selectNodeContents(root.querySelector('[data-pb-code]'));
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      copyMsg.textContent = 'Code sélectionné : copiez-le avec Ctrl+C ou un appui long.';
    }
    try {
      navigator.clipboard.writeText(code).then(function () {
        copyMsg.textContent = 'Code copié.';
        copyBtn.textContent = 'Code copié ✓';
      }, fallback);
    } catch (err) { fallback(); }
  });

  /* Déclenchement (en dernier : toutes les fonctions et variables sont prêtes) */
  if (resume === 'success') {
    open();
    success();
  } else if (resume === 'error') {
    open();
    showServerError(frenchError(Array.prototype.map.call(pageMarker.querySelectorAll('[data-pb-field]'), function (x) {
      return { field: x.getAttribute('data-pb-field'), msg: x.textContent };
    })));
  } else if (preview) {
    open();
    if (previewScratch) showScratch();
  } else if (auto) {
    timer = setTimeout(open, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
